import { fromJS, List, Map } from 'immutable';

export function request(state) {
    return state.set('state', 'IN_PROGRESS');
}

export function finish(state, { countries }) {
    let itemsMap = Map();

    fromJS(countries).forEach(country => {
        itemsMap = itemsMap.set(country.get('id'), country);
    });

    let collections = fromJS(countries).map(g => g.get('id'));

    return state
        .set('items', itemsMap)
        .set('collections', collections)
        .set('state', 'FINISHED');
}

export function error(state, { errors }) {
    return state.set('state', 'ERROR').set('errors', errors);
}
